import { collection, doc, getDocs, query, setDoc, where } from 'firebase/firestore'

import { db } from 'utils/firebase'

import { PendingMembership } from 'types/pendingMemberships'

import { formatQuerySnapshot } from './formatFirestoreResults'

const DOC = 'pendingMemberships'

/**
 * Gets the membership requests for a user based on the ID supplied.
 * @param userId The user ID to fetch the membership requests for.
 * @returns All membership requests for a user.
 */
export const fetchMembershipRequestsByUserId = async (
  userId?: string,
): Promise<Array<PendingMembership> | null> => {
  if (!userId) {
    throw new Error('No user ID passed into fetchMembershipRequestsByUserId')
  }

  const baseQuery = query(
    collection(db, DOC),
    where('status', '==', 'pending'),
    where('program.trainer.id', '==', userId),
  )
  const querySnapshot = await getDocs(baseQuery)
  return formatQuerySnapshot(querySnapshot).sort((a, b) => {
    return b.updated - a.updated
  })
}

export const acceptMembershipRequestForUserId = async (userId: string, programId: string) => {
  const baseQuery = query(
    collection(db, DOC),
    where('userId', '==', userId),
    where('program.id', '==', programId),
  )

  const querySnapshot = await getDocs(baseQuery)
  const results = formatQuerySnapshot(querySnapshot)
  if (results.length === 0) return null

  const dataToUpdate = { status: 'accepted', updated: Date.now() }
  await setDoc(doc(db, DOC, results[0].id), dataToUpdate, { merge: true })
  return dataToUpdate
}

export const declineMembershipRequestByUserIdAndProgramId = async (
  userId: string,
  programId: string,
) => {
  const baseQuery = query(
    collection(db, DOC),
    where('userId', '==', userId),
    where('program.id', '==', programId),
  )

  const querySnapshot = await getDocs(baseQuery)
  const results = formatQuerySnapshot(querySnapshot)
  if (results.length === 0) return null

  const dataToUpdate = { status: 'declined', updated: Date.now() }
  await setDoc(doc(db, DOC, results[0].id), dataToUpdate, { merge: true })
  return dataToUpdate
}
